export default __webpack_public_path__ + "static/media/keystore.6c4eba32.svg";